import React, { useEffect, useState } from "react";
import { API_URL } from "../../constants/appConfig";
import myToast from "../../components/toast";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  Grid,
} from "@mui/material";
import { CurrencyExchange as CurrencyIcon } from "@mui/icons-material";

const Index = () => {
  const [onsGoldPrice, setOnsGoldPrice] = useState({});
  const [dolarPrice, setDolarPrice] = useState({});
  const [gramGold, setGramGold] = useState({});
  const [onsGoldSetPrice, setOnsGoldSetPrice] = useState(null);
  const [dolarSetPrice, setDolarSetPrice] = useState(null);
  const [gramGoldSetPrice, setGramGoldSetPrice] = useState(null);
  const getAllPrices = async () => {
    try {
      const API = API_URL + "/price/getAllPrice";
      const response = await fetch(API);
      const data = await response.json();
      const goldPrice = data?.content.find((price) => price.priceId === "ons");
      const dolarPrice = data?.content.find(
        (price) => price.priceId === "dolar"
      );
      const gramGold = data?.content.find((price) => price.priceId === "gram");
      setGramGold(gramGold);
      setOnsGoldPrice(goldPrice);
      setDolarPrice(dolarPrice);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleUpdatePrice = async (sendedData, UpdatePrice) => {
    try {
      function formatPrice(price) {
        // Fiyatın sadece sayı ve nokta/virgül içerdiğini kontrol et
        if (!/^\d+([.,]\d{0,3})?$/.test(price)) {
          return "ERROR";
        }

        // Nokta işaretini, ondalık ayırıcı olarak virgül işaretiyle değiştirme
        const normalizedPrice = price.replace(".", ",");

        // Virgül ile ayırma
        const [whole, fraction] = normalizedPrice.split(",");

        // Noktalı formatı oluştur
        const formattedWhole = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

        // Kuruş kısmı varsa ekle
        const formattedPrice =
          fraction !== undefined
            ? `${formattedWhole},${fraction}`
            : formattedWhole;

        return formattedPrice;
      }

      const formattedPrice = formatPrice(UpdatePrice);

      if (
        formattedPrice === null ||
        formattedPrice === "" ||
        formattedPrice === undefined
      ) {
        myToast({ status: "error", message: "Lütfen fiyat giriniz" });
        return;
      } else if (formattedPrice === "ERROR") {
        myToast({
          status: "error",
          message:
            "Lütfen geçerli bir fiyat giriniz ÖRN: 2550,70 veya 2550 gibi",
        });
        return;
      } else {
        const formData = {
          ...sendedData,
          price: formattedPrice,
        };

        const API = API_URL + "/price/savePrice";
        const response = await fetch(API, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const data = await response.text();
        if (data) {
          myToast({
            status: "success",
            message: sendedData.priceName + " Fiyatı Güncellendi",
          });

          setOnsGoldSetPrice(null);
          setDolarSetPrice(null);
          setGramGoldSetPrice(null);

          getAllPrices();
        } else {
          myToast({
            status: "error",
            message: sendedData.priceName + " Fiyatı Güncellenemedi",
          });
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAllPrices();
  }, []);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Başlık */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
          Döviz Kurları
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Güncel kur fiyatlarını buradan yönetebilirsiniz
        </Typography>
      </Box>

      {/* Bilgi Mesajı */}
      <Alert 
        severity="info" 
        sx={{ 
          mb: 4,
          '& .MuiAlert-message': {
            fontSize: '0.95rem'
          }
        }}
      >
        Fiyat güncelleme ekranında fiyatları güncelleyebilirsiniz. Güncelleme işlemi yaparken, 
        virgül ile kuruş kısmını girebilirsiniz. Örnek: 2550,70 veya 2550 gibi.
      </Alert>

      {/* Fiyat Kartları */}
      <Grid container spacing={3}>
        {/* Ons Altın */}
        <Grid item xs={12} md={4}>
          <Paper 
            elevation={2}
            sx={{
              p: 3,
              height: '100%',
              borderRadius: 2,
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4
              }
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" color="primary.main" sx={{ mb: 1 }}>
                Ons Altın
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {onsGoldPrice?.price || '0.00'} ₺
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                fullWidth
                label="Yeni Ons Altın Fiyatı"
                value={onsGoldSetPrice || ''}
                onChange={(e) => setOnsGoldSetPrice(e.target.value)}
                type="number"
                size="small"
                InputProps={{
                  inputProps: { step: "0.01" }
                }}
              />
              <Button
                fullWidth
                variant="contained"
                onClick={() => handleUpdatePrice(onsGoldPrice, onsGoldSetPrice)}
                sx={{
                  py: 1,
                  textTransform: 'none',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                  transition: 'transform 0.2s'
                }}
              >
                Güncelle
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Dolar */}
        <Grid item xs={12} md={4}>
          <Paper 
            elevation={2}
            sx={{
              p: 3,
              height: '100%',
              borderRadius: 2,
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4
              }
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" color="info.main" sx={{ mb: 1 }}>
                Dolar
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {dolarPrice?.price || '0.00'} ₺
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                fullWidth
                label="Yeni Dolar Fiyatı"
                value={dolarSetPrice || ''}
                onChange={(e) => setDolarSetPrice(e.target.value)}
                type="number"
                size="small"
                InputProps={{
                  inputProps: { step: "0.01" }
                }}
              />
              <Button
                fullWidth
                variant="contained"
                color="info"
                onClick={() => handleUpdatePrice(dolarPrice, dolarSetPrice)}
                sx={{
                  py: 1,
                  textTransform: 'none',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                  transition: 'transform 0.2s'
                }}
              >
                Güncelle
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Gram Altın */}
        <Grid item xs={12} md={4}>
          <Paper 
            elevation={2}
            sx={{
              p: 3,
              height: '100%',
              borderRadius: 2,
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 4
              }
            }}
          >
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" color="warning.main" sx={{ mb: 1 }}>
                Gram Altın
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {gramGold?.price || '0.00'} ₺
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                fullWidth
                label="Yeni Gram Altın Fiyatı"
                value={gramGoldSetPrice || ''}
                onChange={(e) => setGramGoldSetPrice(e.target.value)}
                type="number"
                size="small"
                InputProps={{
                  inputProps: { step: "0.01" }
                }}
              />
              <Button
                fullWidth
                variant="contained"
                color="warning"
                onClick={() => handleUpdatePrice(gramGold, gramGoldSetPrice)}
                sx={{
                  py: 1,
                  textTransform: 'none',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                  transition: 'transform 0.2s'
                }}
              >
                Güncelle
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Index;
